var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.91667 6.3787L0.729167 4.21821L0 4.93837L2.91667 7.81903L9.16667 1.64619L8.4375 0.926025L2.91667 6.3787Z","fill":"#FEFEFE"}));
}

Tick.defaultProps = {"width":"10","height":"8","viewBox":"0 0 10 8","fill":"none"};

module.exports = Tick;

Tick.default = Tick;
